import React, { useEffect, useState } from "react";
import "./Leaveform.css"; // Import the CSS
import { toast } from "react-toastify";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const Leaveform = () => {
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [leavestatus, setleavestatus] = useState([]);
  const [leaveform, setLeaveform] = useState({
    leaveType: "",
    startDate: "",
    endDate: "",
    tnod: "",
    reason: "",
  });

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const getLeaveRecords = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getleave.php`;
    const formData = new FormData();
    if (userDetails?.role === "admin") {
      formData.append("role", userDetails?.role);
    } else {
      formData.append("user_id", userDetails?.id);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.message === "Leave records fetched successfully") {
        setLeaveRecords(data.data);
        const leavestatus = data.data.filter(
          (task) => String(task.user_id) === String(userDetails.id)
        );
        setleavestatus(leavestatus);
      }
    } catch (error) {
      console.log("Error fetching tasks:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = {
      ...leaveform,
      [name]: value,
    };

    if (updatedForm.startDate && updatedForm.endDate) {
      const start = new Date(updatedForm.startDate);
      const end = new Date(updatedForm.endDate);

      if (start <= end) {
        const diffTime = end.getTime() - start.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        updatedForm.tnod = diffDays.toString(); // convert to string to keep consistent with input type
      } else {
        updatedForm.tnod = "";
      }
    }

    setLeaveform(updatedForm);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (leaveform.startDate === leaveform.endDate) {
      toast.error("Start date and end date cannot be the same");
      return;
    }

    if (new Date(leaveform.startDate) > new Date(leaveform.endDate)) {
      toast.error("Start date cannot be greater than end date");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/leaveform.php`;
    const formData = new FormData();

    formData.append("user_id", userDetails?.id);
    formData.append("type", leaveform.leaveType);
    formData.append("start_date", leaveform.startDate);
    formData.append("end_date", leaveform.endDate);
    formData.append("count_of_days", leaveform.tnod);
    formData.append("reason", leaveform.reason);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.message === "Leave request added successfully.") {
        toast.success("Leave request submitted successfully!");
        setLeaveform({
          leaveType: "",
          startDate: "",
          endDate: "",
          tnod: "",
          reason: "",
        });
        getLeaveRecords();
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error with POST request:", error);
      toast.error("Failed to submit leave request.");
    }
  };

  const handleleaveupdate = async (
    id,
    user_id,
    startDate,
    endDate,
    type,
    tnod,
    e
  ) => {
    e.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/leaveformupdate.php`;
    const formData = new FormData();

    formData.append("id", id);
    formData.append("user_id", user_id);
    formData.append("responseby_id", userDetails?.id);

    if (type === "approved") {
      formData.append("start_date", startDate);
      formData.append("end_date", endDate);
      formData.append("count_of_days", tnod);
      formData.append("status", type);
    } else {
      formData.append("status", type);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Leave details updated successfully.") {
        toast.success("Leave details updated successfully!");
        getLeaveRecords();
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error with POST request:", error);
      toast.error("Failed to update leave request.");
    }
  };

  useEffect(() => {
    // if (userDetails?.role !== "admin") {
    getLeaveRecords();
    // }
  }, []);

  const approval = "approved";
  const declined = "declined";

  const isAdminOrManager = userDetails?.role === "admin";
  const rows = isAdminOrManager ? leaveRecords : leavestatus;

  const [editingRowId, setEditingRowId] = useState(null);

  const handleDateChange = (id, field, value) => {
    const update = (prev) =>
      prev.map((rec) => {
        if (rec.id !== id) return rec;

        const updated = { ...rec, [field]: value };
        if (updated.start_date && updated.end_date) {
          const start = new Date(updated.start_date);
          const end = new Date(updated.end_date);
          const diff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
          updated.count_of_days = diff > 0 ? diff : 0;
        }

        return updated;
      });

    if (userDetails?.role !== "employee") {
      setLeaveRecords(update);
    } else {
      setleavestatus(update);
    }
  };

  return (
    <>
      {userDetails?.role !== "admin" && (
        <div className="leave-form-container">
          <h2 className="head1">Leave Application Form</h2>
          <form onSubmit={handleSubmit} className="leave-form">
            <div>
              <label>Leave Type</label>
              <select
                name="leaveType"
                value={leaveform.leaveType}
                onChange={handleChange}
                required
              >
                <option value="">Select Type</option>
                <option value="casual">Casual Leave</option>
                <option value="sick">Sick Leave</option>
                <option value="earned">Earned Leave</option>
              </select>
            </div>

            <input
              type="date"
              name="startDate"
              value={leaveform.startDate}
              onChange={handleChange}
              required
              min={new Date().toISOString().split("T")[0]} // 👈 Prevent past dates
            />

            <input
              type="date"
              name="endDate"
              value={leaveform.endDate}
              onChange={handleChange}
              required
              min={
                leaveform.startDate || new Date().toISOString().split("T")[0]
              } // 👈 Prevent before start date
            />

            <div>
              <label>Total No. Days</label>
              <input
                type="number"
                name="tnod"
                placeholder="Total number of days"
                value={leaveform.tnod}
                readOnly
                required
              />
            </div>

            <div>
              <label>Reason</label>
              <textarea
                name="reason"
                placeholder="Enter the reason for leave"
                value={leaveform.reason}
                onChange={handleChange}
                rows="3"
                required
              ></textarea>
            </div>

            <button type="submit" className="assign-btn">
              Submit Leave Request
            </button>
          </form>
        </div>
      )}

      <div className="leave-table-container">
        {userDetails?.role !== "admin" ? (
          <h2 className="head1">Leave History</h2>
        ) : (
          <h2 className="head1">Employee Leave Requests</h2>
        )}
        <div className="table-scroll">
          <table className="leave-history-table">
            <thead>
              <tr>
                <th>SI.NO</th>
                {userDetails?.role === "admin" && <th>Employee Name</th>}
                <th>Type</th>
                <th>Start</th>
                <th>End</th>
                <th>No. of Days</th>
                <th>Reason</th>
                <th>Status</th>
                {userDetails?.role === "admin" && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((record, index) => (
                  <tr key={index}>
                    <td className="tdh">{index + 1}.</td>

                    {userDetails?.role === "admin" && (
                      <td>{record.emp_name}</td>
                    )}

                    <td>{record.type}</td>

                    {userDetails?.role === "admin" ? (
                      <>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {editingRowId === record.id ? (
                            <input
                              type="date"
                              value={record.start_date}
                              onChange={(e) =>
                                handleDateChange(
                                  record.id,
                                  "start_date",
                                  e.target.value
                                )
                              }
                              min={new Date().toISOString().split("T")[0]} // Prevent past dates
                            />
                          ) : (
                            record.start_date
                          )}
                        </td>

                        <td style={{ whiteSpace: "nowrap" }}>
                          {editingRowId === record.id ? (
                            <input
                              type="date"
                              value={record.end_date}
                              onChange={(e) =>
                                handleDateChange(
                                  record.id,
                                  "end_date",
                                  e.target.value
                                )
                              }
                              min={
                                record.start_date ||
                                new Date().toISOString().split("T")[0]
                              }
                            />
                          ) : (
                            record.end_date
                          )}
                        </td>

                        <td>
                          {editingRowId === record.id ? (
                            <>
                              <label
                                style={{
                                  display: "block",
                                  fontSize: "12px",
                                  color: "#555",
                                }}
                              >
                                Total No. Days
                              </label>
                              <input
                                type="number"
                                name="tnod"
                                value={record.count_of_days}
                                readOnly
                                required
                                style={{ width: "60px" }}
                              />
                            </>
                          ) : (
                            record.count_of_days
                          )}
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {record.start_date}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {record.end_date}
                        </td>
                        <td>{record.count_of_days}</td>
                      </>
                    )}

                    <td>{record.reason}</td>
                    <td>{record.status}</td>

                    {userDetails?.role === "admin" && (
                      <td>
                        <div style={{ display: "flex", gap: "8px" }}>
                          {editingRowId === record.id ? (
                            <>
                              <button
                                className="leave-action-btn approve"
                                onClick={(e) =>
                                  handleleaveupdate(
                                    record.id,
                                    record.user_id,
                                    record.start_date,
                                    record.end_date,
                                    "approved",
                                    record.count_of_days,
                                    e
                                  )
                                }
                              >
                                <FaCheckCircle style={{ marginRight: "6px" }} />
                              </button>

                              <button
                                className="leave-action-btn decline"
                                onClick={(e) =>
                                  handleleaveupdate(
                                    record.id,
                                    record.user_id,
                                    record.start_date,
                                    record.end_date,
                                    "declined",
                                    record.count_of_days,
                                    e
                                  )
                                }
                              >
                                <FaTimesCircle style={{ marginRight: "6px" }} />
                              </button>

                              <button
                                className="done-btn"
                                onClick={() => setEditingRowId(null)}
                              >
                                <FaCheckCircle style={{ marginRight: "6px" }} />
                                Done
                              </button>
                            </>
                          ) : record.status === "applied" ? (
                            <>
                              <button
                                className="leave-action-btn approve"
                                onClick={(e) =>
                                  handleleaveupdate(
                                    record.id,
                                    record.user_id,
                                    record.start_date,
                                    record.end_date,
                                    "approved",
                                    record.count_of_days,
                                    e
                                  )
                                }
                              >
                                <FaCheckCircle style={{ marginRight: "6px" }} />
                              </button>

                              <button
                                className="leave-action-btn decline"
                                onClick={(e) =>
                                  handleleaveupdate(
                                    record.id,
                                    record.user_id,
                                    record.start_date,
                                    record.end_date,
                                    "declined",
                                    record.count_of_days,
                                    e
                                  )
                                }
                              >
                                <FaTimesCircle style={{ marginRight: "6px" }} />
                              </button>

                              <button
                                className="edit-btn"
                                onClick={() => setEditingRowId(record.id)}
                              >
                                ✏️ Edit
                              </button>
                            </>
                          ) : (
                            <button
                              className="edit-btn"
                              onClick={() => setEditingRowId(record.id)}
                            >
                              ✏️ Edit
                            </button>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">No leave records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Leaveform;
